import React from "react";
import { SiTailwindcss, SiReact } from "react-icons/si";
import { BiArrowToTop } from "react-icons/bi";

const Footer = () => {

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <div className="w-[96%] h-full bg-bodyColor rounded-2xl z--1 p-2">
            <div className="flex flex-col gap-2 text-center">
                <p>Made with React <SiReact className="inline" /> & Tailwind <SiTailwindcss className="inline" /></p>
                <div className="h-full text-center px-4">
                    <p className="">© 2025 Zakawat Abbas | Portfolio. All rights reserved.</p>
                    <BiArrowToTop onClick={scrollToTop} className="moveToTop text-3xl self-center font-semibold hover:text-designColor cursor-pointer ml-auto my-3 inline-block lgl:hidden" />
                </div>
            </div>
        </div>
    );
};

export default Footer;